import { createFileRoute } from '@tanstack/react-router';
import { ProjectsView } from '../components/features/project/index.js';

/**
 * @graph-node {Page}
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business aC Div看板ページ。PI Div の PMO（pi_pmot）が aC Div の案件を横断 PMO ビューでスコープ表示する。ProjectsView に forcedDivision='ac_div' を渡す
 * @graph-connects ProjectsView [calls] aC Div スコープのプロジェクト一覧ビュー描画
 */
export const Route = createFileRoute('/projects/ac-div-board')({
  component: AcDivBoardPage,
});

/** @graph-connects ProjectsView [calls] aC Div スコープのプロジェクト一覧ビュー描画 */
function AcDivBoardPage() {
  return <ProjectsView pageKey="acDivBoard" forcedDivision="ac_div" />;
}
